export const currencyKR = (value: any, type = '') => {
  if (!value) return '0원';

  const koreanUnits = ['', '만', '억', '조'];
  let answer = '';
  let unit = 10000;
  let index = 0;
  let division = Math.pow(unit, index);

  while (Math.floor(value / division) > 0) {
    const mod = Math.floor((value % (division * unit)) / division);
    if (mod) {
      let modToString = mod.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      if (type === '2' && mod.toString().length > 3) {
        // 천단위도 한글로 표시
        modToString = mod.toString().replace(/(\d{3})+(?!\d)/g, '천');
      }

      if (type === '3' && mod.toString().length > 3) {
        // 천단위도 한글로 표시
        modToString = mod.toString().replace(/(\d{3})+(?!\d)/g, '천');
      }

      //if (koreanUnits[index] === "억") {
      answer = `${modToString}${koreanUnits[index]} ` + answer;
      //} else {
      //  answer = `${modToString}${koreanUnits[index]}` + answer;
      //}
    }
    division = Math.pow(unit, ++index);
  }

  return answer === ''
    ? '0원'
    : type === '3'
    ? answer + '만 원'
    : answer + ' 원';
};

// export const filter = (value:any, unit = 0) => {
//     return value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
// };

export const currency = (value: any, unit = 0) => {
  if (unit === 10000) {
    value = parseInt(value, 10) * 0.0001;
  }

  return parseInt(value, 10)
    .toFixed(0)
    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
};

export const joinDtDate = (value: any, unit: string) => {
  if (!value) return;
  return value.replace(/(\d{4})(\d{2})/, `$1${unit}$2`);
};

export const mtgJoinDtDate = (value: any, unit: string) => {
  if (!value) return;
  value = value.replace(/\./g, '');
  return value.replace(/(\d{4})(\d{2})(\d{2})/, `$1${unit}$2${unit}$3`);
};

export const compNo = (value: string) => {
  return value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
};

export const decimalNumber = (value: string) => {
  return value.replace(/(\d{2})(\d{2})/g, '$1.$2');
};

export const addUnitToMaxAmount = (value: number) => {
  let result;
  if (!value) return '';
  if (value >= 100000000) {
    result =
      ((Math.round(value / 10000000) * 10000000) / 100000000).toString() +
      '억 원';
  } else {
    result =
      (value / 10000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      '만 원';
  }

  return result;
};

export const filterJobLabel = (title: string, val: string) => {
  if (title === '직업') {
    if (val === '기타') {
      return '기타(프리랜서 등)';
    } else if (val === '무직') {
      return '무직(주부 등)';
    } else if (val === '전문직') {
      return '전문직(급여소득자)';
    } else {
      return val;
    }
  } else {
    return val;
  }
};
